import { render } from "./Agreements.vue?vue&type=template&id=76b86401&scoped=true"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"

import "./Agreements.vue?vue&type=style&index=0&id=76b86401&lang=scss"
import "./Agreements.vue?vue&type=style&index=1&id=76b86401&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b86401"]])

export default __exports__